import React, { useEffect, useState } from "react";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
function ShowOrder(props) {
  var history = useHistory();
  const [orderlist, setOrderslist] = useState([]);
  const [address, setAddress] = useState("");
  const [customer, setCustomer] = useState("");
  const [rider, setRider] = useState("");
  const [riderFare, setRiderFare] = useState("");
  const [riderTip, setRiderTip] = useState("");
  const { id } = props.match.params;
 
  useEffect(() => {
    axios
      .get(`${Baseurl.baseurl3}/order/get-order/${id}`)
      .then((res) => {
        axios
          .get(
            `${Baseurl.baseurl3}/user/get-user-details/${res.data.order.Customer}`
          )
          .then((response) => {
            setCustomer(response.data.user);
          })
          .catch((err) => {
            if (err.toString() === "Error: Network Error") {
              history.push("/offline");
            } else {
              history.push("/400");
            }
          });
        axios
          .get(
            Baseurl.baseurl3 +
            `/rider/get-rider-details/${res.data.order.OrderDeliveryBoy._id}`
          )
          .then((response) => {
            setRider(response.data.data);
          });
        setRiderFare(
          res.data.order.RiderPrice.RideFare +
            res.data.order.RiderPrice.Tip
        );
        setOrderslist(res.data.order);
        setRiderTip(res.data.order.RiderPrice.Tip);
        setAddress(orderlist.Address);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }, []);
  return (
    <div className="h-80">
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <div
            className="card"
            style={{
              color: "white",
              background:
                "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
            }}
          >
            <div className="card-header">
              <h5
                className={
                  orderlist.OrderStatus == "Completed"
                    ? "bg-success p-1 pl-3 pr-3 rounded-pill"
                    : "Pending"
                    ? "bg-danger p-1 pl-3 pr-3 rounded-pill text-white"
                    : "rounded-pill bg-warning p-1 pl-3 pr-3"
                }
              >
                {orderlist.OrderStatus}
              </h5>
              <button
                className="btn btn-primary float-right"
                onClick={() => {
                  history.goBack();
                }}
              >
                Back
              </button>
            </div>
            <div className="card-body">
              <Table id="myTable" responsive>
                <tbody>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">OrderID:</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist._id}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">OrderType:</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist.OrderType}</h5>
                    </td>
                  </tr>
                  {orderlist.Address &&
                    orderlist.Address.map((val) => {
                      if (val.Origin) {
                        return (
                          <tr>
                            <td>
                              <div className="col-sm-12">
                                <h5 className="text-white">Pickup address:</h5>
                              </div>
                            </td>
                            <td>
                              <h5 className="text-white">
                                Code:{val.Code}
                                <br /> Name: {val.Name} <br />
                                Contact: {val.Contact}
                                <br /> Address: {val.Address}
                              </h5>
                              {val.Photo &&
                                val.Photo.map((item) => {
                                  return (
                                    <div
                                      style={{
                                        marginTop: "5px",
                                        width: 180,
                                        height: 100,
                                        aspectRatio: 1 * 1.4,
                                      }}
                                      className="col-sm-8"
                                    >
                                      <img
                                        alt=""
                                        style={{
                                          resizeMode: "cover",
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        className="playerProfilePic_home_tile"
                                        src={item}
                                      />
                                    </div>
                                  );
                                })}
                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr>
                            <td>
                              <div className="col-sm-12">
                                <h5 className="text-white">Drop address:</h5>
                              </div>
                            </td>
                            <td>
                              <h5 className="text-white">
                                Code:{val.Code}
                                <br /> Name: {val.Name} <br />
                                Contact: {val.Contact}
                                <br /> Address: {val.Address}
                              </h5>
                              {val.Photo &&
                                val.Photo.map((item) => {
                                  return (
                                    <div
                                      style={{
                                        marginTop: "5px",
                                        width: 180,
                                        height: 100,
                                        aspectRatio: 1 * 1.4,
                                      }}
                                      className="col-sm-8"
                                    >
                                      <img
                                        alt=""
                                        style={{
                                          resizeMode: "cover",
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        className="playerProfilePic_home_tile"
                                        src={item}
                                      />
                                    </div>
                                  );
                                })}
                            </td>
                          </tr>
                        );
                      }
                    })}
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Item type:</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist.ItemType}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Helper:</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">
                        {orderlist.Helper ? "added" : "Not Added"}
                      </h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Customer Details:</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist.Customer}</h5>
                      <h5 className="text-white">{customer.Name}</h5>
                      <h5 className="text-white">{customer.Phone}</h5>
                      <h5 className="text-white">{customer.Email}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Deliveryboy Details</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">
                        {orderlist.OrderDeliveryBoy}
                      </h5>
                      {rider && (
                        <>
                          <h5 className="text-white">
                            {rider.riderFirstName} {rider.riderLastName}
                          </h5>
                          <h5 className="text-white">{rider.riderPhone}</h5>
                          <h5 className="text-white">
                            {rider.RiderVehicleType.name}
                          </h5>
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Rider Earning:</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{riderFare}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Cost of order</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist.OrderPrice}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Payment type</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist.PaymentType}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Payment status</h5>
                      </div>
                    </td>
                    {orderlist.PaidOnline ? (
                      <td>
                        <h5 className="text-white">Paid</h5>
                      </td>
                    ) : (
                      <td>
                        <h5 className="text-white">Unpaid</h5>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Date</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">
                        {orderlist.Date}th {orderlist.Month} {orderlist.Year} at{" "}
                        {orderlist.Hour} O'Clock
                      </h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Rider tips</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{riderTip}</h5>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Penalty</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">{orderlist.Penalty}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Company Earnings</h5>
                      </div>
                    </td>
                    <td>
                      <h5 className="text-white">
                        {orderlist.CompanyEarnings}
                      </h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="col-sm-12">
                        <h5 className="text-white">Refund</h5>
                      </div>
                    </td>
                    <td>
                      <div className="row">
                        <div class="form-group" className="col-sm-8">
                          <input
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            placeholder="Enter Amount to Refund"
                            class="form-control"
                            id="usr"
                            inputMode="numeric"
                          />
                        </div>{" "}
                        <div className="col-sm-2">
                          <button className="btn btn-primary">Submit</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowOrder;
